import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import { FooterMain } from "../styles/FooterStyle";
import { RiTwitterXFill } from "react-icons/ri";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <FooterMain className="footer_main txt_color">
      <div className="container">
        <div className="footer_row">
          <div className="footer_links">
            <p className="linkHeadin">Company</p>
            <Link to="/about">About us</Link>
            <Link to="/contact">Contact Us</Link>

            <br />

            <p className="linkHeadin">Legal & Policies</p>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/legal-disclaimer">Legal Disclaimer</Link>

            <Link to="/term-and-condition">Terms & Conditions</Link>
          </div>
          {/* <div className="feedback_form">
            <div>
              <h2>We value your feedback</h2>
              <input
                type="text"
                name="feedback"
                placeholder="Write your feedback..."
                onChange={(e) => setFeedbackText(e.target.value)}
                value={feedbackText}
              />
              <button className={"feedback_btn  disabled"} disabled={true}>
                feedback
              </button>
            </div>
          </div> */}

          <div className="footer_links">
            <p className="linkHeadin">Partner</p>
            <Link to="/become-our-partner">Become Our Partner </Link>
            <Link to="/investment">Investment </Link>
            <br />

            <p className="linkHeadin">Quick Links</p>
            <Link to="/careers">Careers</Link>
            <Link to="/news-update">News & Updates</Link>
            <Link to="/web-sitemap">Sitemap</Link>
          </div>
          <div className="footer_links">
            <p className="linkHeadin">Our Other Websites</p>
            <Link
              to="https://alpharegiment.in/"
              target="_blank"
              rel="nofollow noreferrer"
            >
              Alpha Regiment
            </Link>

            <Link
              to="https://ssbgpt.in"
              target="_blank"
              rel="nofollow noreferrer"
            >
              SSB-GPT
            </Link>
            <Link
              to="https://experimentadda.in/"
              target="_blank"
              rel="nofollow noreferrer"
            >
              Experiment Adda
            </Link>
            <Link to="https://ndagpt.in">
              NDA-GPT
            </Link>
            <Link to="https://afcatgpt.in">
              AFCAT-GPT
            </Link>
            <Link to="https://cdsgpt.in">
              CDA-GPT
            </Link>
            <Link to="https://inetgpt.in">
              INET-GPT
            </Link>
          </div>
          <div className="footer_links">
            <div className="links">
              <Link
                to="https://www.instagram.com/arcaptor?igsh=NzZ2aXN6a2xiMWM3"
                target="_blank"
                title="Instagram"
                rel="nofollow noopener"
              >
                <FaInstagram />
              </Link>
              <Link
                to="https://www.youtube.com/@arcaptortechnologies"
                target="_blank"
                title="Youtube"
                rel="nofollow noopener"
              >
                <FaYoutube />
              </Link>
              <Link
                to="https://www.linkedin.com/company/arcaptor-technologies/"
                target="_blank"
                title="Linkedin"
                rel="nofollow noopener"
              >
                <FaLinkedin />
              </Link>
              <Link
                to="https://www.facebook.com/arcaptor"
                target="_blank"
                title="Facebook"
                rel="nofollow noopener"
              >
                <FaFacebookF />
              </Link>
              <Link
                to="https://x.com/Arcaptortech"
                target="_blank"
                title="Twitter"
                rel="nofollow noopener"
              >
                <RiTwitterXFill />
              </Link>
            </div>
            <Link to="/" className="logo" style={{ border: "none" }}>
              <img
                className="img-fluid"
                src="/images/logo_main.png"
                alt="logo"
              />
            </Link>
          </div>
        </div>
      </div>
      <p className="copyright_txt">
        Copyright © {currentYear} Arcaptor Technologies
      </p>
    </FooterMain>
  );
};

export default Footer;
